<template>
  <!--
    // 主頁貼文牆-正式機: https://gawbue.lale.im/gawbueVue/index.html#/postWall/{token}
    // 主頁貼文牆-測試機: http://192.168.13.4:8092/gawbueVue/index.html#/postWall/{token}

    // 我的貼文牆: https://gawbue.lale.im/gawbueVue/index.html#/myPost/{token}
    // 某位朋友的貼文牆: https://gawbue.lale.im/gawbueVue/index.html#/friendPost/@limeng.chen:lalepass.lale.im/{token}
    // 相簿:https://gawbue.lale.im/gawbueVue/index.html#/album/{token}
    // 鈴鐺通知:https://gawbue.lale.im/gawbueVue/index.html#/noticeMessage/{token}
  -->
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
export default {
  mounted() {
    // 初始化 session 與取得 user 資訊
    // this.initSessionAndUserInfo();
    this.initSession();

    // 判斷需不需要推高 ios 的咬版問題
    this.checkIosBite();

    // 前往鈴鐺通知頁(提供 APP 呼叫的 function)
    window.goNoticeMessagePage = () => {
      this.$router.push({ name: 'NoticeMessage' });
    };

    // ============= 拿小鈴鐺通知 =============
    // 更新頻率為20秒一次
    setInterval(() => {
      this.callNoticeMessage();
    }, 20000);
  },
  computed: {
    ...mapGetters(['getToken', 'getSessionType'])
  },
  updated() {
    // 若頁面不是 通知中心頁面(noticeMessage) 或 單一貼文頁面(onePost) 就重置 notificationData
    if (this.$route.name !== 'OnePost' && this.$route.name !== 'NoticeMessage') {
      this.INIT_NOTIFICATION_DATA();
    }
  },
  created() {
    this.getThirdPartyLoginToken();
    // const token = localStorage.getItem('laleToken');
    // if (token) {
    //   this.SET_TOKEN({token});
    // }
  },
  methods: {
    ...mapState(['token']),
    ...mapActions(['setTokenToSession', 'getApiUserInfo', 'callNoticeMessage']),
    ...mapMutations(['SET_TOKEN']),
    ...mapMutations('NoticeMessageModule', ['INIT_NOTIFICATION_DATA']),
    // @第三方登入:
    ...mapActions('thirdPartyLoginModule', ['getLINEUserInfo', 'getLineLoginToken', 'getFbLoginToken']),
    // 初始化 session 與取得 user 資訊
    // initSessionAndUserInfo() {
    //   // =============== 新版兼容舊版，舊版 login.html 所導入的方式，login.html 已存 session，因此不須跑以下程式
    //   // 沒有 localStorage 的 domain 是新版的用戶，或是此 url 有帶 token 參數即會判斷為新版
    //   if (!localStorage.getItem('domain') || this.$route.params.token) {
    //     console.log('新版:直接從該頁面進入');
    //     // 清除舊版的 localStorage(從 public\login.html 存入的)
    //     localStorage.removeItem('domain');
    //     // 沒有存過 token 或是存過的 session 與現在頁面所需的 session 種類不同，就執行取 token 存 session 的動作
    //     if (this.getToken === '' || this.getSessionType !== this.$route.name) {
    //       let routerName = this.$route.name;
    //       let token = this.$route.params.token;
    //       let fid = this.$route.params.fid;
    //       // 若網址後方有帶有 /token/xxxx 為從其他 AP 分享過來的資訊(從消息/活動/買迷分享至友圈)，需要建立 session
    //       if (location.href.indexOf('/token/') > -1) {
    //         let tokenIdx = location.href.indexOf('/token/');
    //         token = location.href.slice(tokenIdx + 7);
    //         routerName = 'PostWall';
    //       }
    //       // 依 routerName 的不同來決定存入哪一種 session
    //       this.setTokenToSession({ token, routerName, fid });
    //     } else {
    //       // 拿該名使用者資料
    //       this.getApiUserInfo();
    //     }
    //   } else {
    //     console.log('從 login.html 導入');
    //     // =============== 舊版本 login.html 所導入的方式
    //     let sessionPayload = {
    //       token: localStorage.getItem('laleToken'),
    //       routerName: this.$route.name
    //     };
    //     this.SET_TOKEN(sessionPayload);
    //     if (location.href.indexOf('/token/') > -1) {
    //       // 若網址後方有帶有 /token/xxxx 為從其他 AP 分享過來的資訊(從消息/活動/買迷分享至友圈)，需要建立 session
    //       let tokenIdx = location.href.indexOf('/token/');
    //       let fid = null;
    //       token = location.href.slice(tokenIdx + 7);
    //       routerName = 'PostWall';
    //       this.setTokenToSession({ token, routerName, fid });
    //     } else {
    //       this.getApiUserInfo();
    //     }
    //   }
    // },

    initSession() {
      let routerName = this.$route.name;
      let token = this.$route.params.token;
      let thirdPartyTokenCheck = localStorage.getItem('laleToken');
      let fid = this.$route.params.fid;
      // 若網址後方有帶有 /token/xxxx 為從其他 AP 分享過來的資訊(從消息/活動/買迷分享至友圈)，需要建立 session
      if (location.href.indexOf('/token/') > -1) {
        let tokenIdx = location.href.indexOf('/token/');
        token = location.href.slice(tokenIdx + 7);
        routerName = 'PostWall';
      }

      if (token || thirdPartyTokenCheck) {
        // 依 routerName 的不同來決定存入哪一種 session
        this.setTokenToSession({ token, routerName, fid });
      }
    },

    // 判斷需不需要推高 ios 的咬版問題
    checkIosBite() {
      // 判斷iOS
      const myUserAgent = navigator.userAgent;
      let isiOS = !!myUserAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // 判斷是否需要推高(從 相簿、我的貼文牆、朋友貼文牆 進入的地方會被咬版)
      let isBite = document.URL.match(/album/g) || document.URL.match(/myPost/g) || document.URL.match(/friendPost/g);
      // 加上推版
      let element = document.getElementById('gawbueBody');
      if (isiOS && isBite) {
        element.classList.add('pushiOS');
      }
    },
    // @第三方登入: 取得 FB 或 Line 登入後回傳的 token
    async getThirdPartyLoginToken() {
      const code = new URL(location.href).searchParams.get('code');
      const state = new URL(location.href).searchParams.get('state');
      console.log(`code====${code}; state=====${state}`);
      if (code && state === 'fb') {
        this.getFbLoginToken(code);
      } else if (code && state === 'line') {
        await this.getLineLoginToken(code);
      }
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap');

body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
